<mat-form-field style="flex: 1; width: 100%;">
  <input matInput type="text" #fundo placeholder="Fundo" (onfocus)="handleFocus()" [value]="(filtroFundo | async)" (keyup)="handleFiltro($event.target.value)" [matAutocomplete]="auto">
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFundo" (optionSelected)="selectFundo($event.option.value)">
  <mat-option *ngFor="let option of (fundos$ | async)" [value]="option">{{option.cnpj | mask:'00.000.000/0000-00'}} - {{option.nome}}</mat-option>
</mat-autocomplete>